import { ConfirmationPopupPropsActions } from '../../molecules/ConfirmationPopup';
import { NotFoundPropsMicrocopy } from '../../molecules/NotFound';
import { PaginationPropsMicrocopy } from '../../molecules/Pagination';
import { ReportReviewModalPropsActions } from '../ReportReviewModal';
import {
  UserProductReviewPropsData,
  UserProductReviewPropsMicrocopy,
} from '../UserProductReview';
import {
  ReviewFormData,
  WriteReviewModalPropsActions,
  WriteReviewModalPropsData,
  WriteReviewModalPropsMicrocopy,
} from '../WriteReviewModal';

export const enum ProductReviewFilterValues {
  DEFAULT = '',
  ONE_STAR = '1',
  TWO_STARS = '2',
  THREE_STARS = '3',
  FOUR_STARS = '4',
  FIVE_STARS = '5',
}

export type ProductReviewFilterOptions = {
  label: string;
  value: ProductReviewFilterValues;
};

export const enum ProductReviewSortByValues {
  RECENT = 'recent',
  RATING = 'rating',
}

export type ProductReviewSortByOptions = {
  label: string;
  value: ProductReviewSortByValues;
};

export type ProductReviewsPropsMicrocopy = UserProductReviewPropsMicrocopy & {
  reviews: string;
  filters: string;
  sortBy: string;
  filterOptions: string[];
  sortOptions: string[];
  results: string;
  rating: string;
  mostRecent: string;
  helpfulness: string;
  emptyState?: {
    title: string;
    description: string;
    cta: string;
    writeReviewModal?: WriteReviewModalPropsMicrocopy;
  };
  pagination: PaginationPropsMicrocopy;
  notFound?: NotFoundPropsMicrocopy;
};

export type ProductReviewsPropsData = {
  activeFilterValue?: ProductReviewFilterValues;
  reviews: UserProductReviewPropsData[];
  start: number;
  end: number;
  total: number;
  currentPage: number;
  totalPages: number;
  writeReviewModal: WriteReviewModalPropsData;
};

export type ProductReviewsPropsActions = WriteReviewModalPropsActions &
  ConfirmationPopupPropsActions &
  ReportReviewModalPropsActions & {
    onHelpfulVotesReview: (reviewId: string) => void;
    onEditReview: (
      reviewId: string,
      formData: ReviewFormData,
      lastUpdatedAt: string
    ) => Promise<void>;
    onHelpfulVotesReply: (replyId: string) => void;
    onEditReply: (replyId: string) => void;
    onDeleteReply: (replyId: string) => void;
    onSubmitReply: (reply: string, replyId?: string) => void;
    onFilter: (filter: string) => void;
    onSort: (sort: ProductReviewSortByValues) => void;
    onPageChange: (page: number) => void;
    onClickEmptyStateCta?: () => void;
  };

export type ProductReviewsPropsDataWithMicrocopy = {
  microcopy: ProductReviewsPropsMicrocopy;
} & ProductReviewsPropsData;

export type ProductReviewsProps = ProductReviewsPropsDataWithMicrocopy &
  ProductReviewsPropsActions & {
    className?: string;
  };
